import { PageCriteriaDTO } from '@dto/PageCriteriaDTO';
import { InsuranceType } from '@enum/doctor/InsuranceType';
import { EventStatus } from '@enum/event/EventStatus';

export class EventPageCriteriaDTO extends PageCriteriaDTO {
  public insuranceType: InsuranceType;

  public status: EventStatus | string;
}